import React from 'react';
import { Card, CardContent } from '../../components/ui/card';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-cream" data-testid="refund-policy-page">
      <section className="bg-terracotta py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="font-heading text-4xl text-white">Refund & Cancellation Policy</h1>
          <p className="font-body text-white/80 mt-2">Last updated: January 2026</p>
        </div>
      </section>
      
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4">
          <Card className="bg-white rounded-2xl border-none shadow-sm">
            <CardContent className="p-8 md:p-12 space-y-8 font-body text-gray-700 leading-relaxed">
              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Donation Policy</h2>
                <p>Donations made to Dharma Astra Association are contributions to support our charitable activities including temple construction, cultural preservation, and social welfare programs. We appreciate every donation and the trust you place in us.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Refund Eligibility</h2>
                <p className="mb-4">Refunds may be considered in the following circumstances:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Duplicate Payment:</strong> If you have accidentally made the same donation twice, we will refund the duplicate amount.</li>
                  <li><strong>Incorrect Amount:</strong> If you were charged an amount significantly different from what you intended to donate due to a technical error.</li>
                  <li><strong>Unauthorized Transaction:</strong> If you believe your payment method was used without your authorization.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Refund Process</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Refund requests must be made within 7 days of the donation date.</li>
                  <li>Submit your request via email to info@dharmastra.org with your donation receipt, transaction ID, and reason for refund.</li>
                  <li>Refund requests are reviewed within 7-10 business days.</li>
                  <li>Approved refunds will be processed within 15-20 business days to the original payment method.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Recurring Donations (Monthly)</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Monthly recurring donations can be cancelled at any time by contacting us.</li>
                  <li>Cancellation requests must be received at least 5 days before the next billing date.</li>
                  <li>No refunds will be issued for payments already processed.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Non-Refundable Donations</h2>
                <p>Please note that donations made for specific religious ceremonies, prasadam distribution, or completed projects are generally non-refundable as these funds are utilized immediately.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Tax Implications</h2>
                <p>If a refund is processed after an 80G certificate has been issued, the certificate will be cancelled and you may need to report this to your tax consultant.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">Contact Us</h2>
                <p>For refund requests or queries:</p>
                <p className="mt-2">Email: support@dharma-astra.org<br />Phone: +91 8977116677</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default RefundPolicy;
